import * as Sentry from "@sentry/react";
import { toast } from "react-toastify";
import { GatewayLoadError } from "./validateCardWithGateway";

export const GATEWAY_LOAD_FAILURE_MESSAGE =
  "Não foi possível validar o cartão agora. Verifique sua conexão e tente novamente.";

type NotifyGatewayLoadFailureOptions = {
  /** Kill switch do Sentry do fluxo de cartão; o toast não depende dele. */
  sentryEnabled?: boolean;
};

export const notifyGatewayLoadFailure = (
  error: unknown,
  { sentryEnabled = true }: NotifyGatewayLoadFailureOptions = {}
) => {
  const isDownloadFailure = error instanceof GatewayLoadError;
  if (sentryEnabled) {
    Sentry.withScope(scope => {
      scope.setTag("flow", isDownloadFailure ? "load_gateway" : "validate_card");
      if (isDownloadFailure) scope.setExtra("cause", String(error.cause));
      Sentry.captureException(error);
    });
  }
  toast.error(GATEWAY_LOAD_FAILURE_MESSAGE);
};
